import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {stringUtils} from 'front-onceforall-core';
import {notificationType} from '../../../../utils/constant';

function MessageView({invitation}) {
  function getTradParams() {
    switch (invitation.type) {
      case notificationType.RELATIONSHIP_NOT_AUTOMATICALLY_ACCEPTED:
        // falls through
      case notificationType.projectInvitedBy:
        return {invitingOrganisationName: invitation.relationship?.invitingOrganisationName};
      case notificationType.RELATIONSHIP_SUGGESTED:
        return {invitingOrganisationName: invitation.invitingOrganisationName};
      case notificationType.PROJECT_NOT_AUTOMATICALLY_ACCEPTED:
        return {projectName: invitation.intervention?.projectName};
      case notificationType.USER_PENDING:
        return {firstName: invitation.user?.firstName,
          lastName: invitation.user?.lastName};
      default: return {};
    }
  }

  return (
    <>
      <div>
        {stringUtils.getStrongs(I18n.t(`invitation.received.message.${invitation.type}`, getTradParams()))}
      </div>
      {invitation.type === notificationType.PROJECT_NOT_AUTOMATICALLY_ACCEPTED &&
        <div>
          {stringUtils.getStrongs(I18n.t('invitation.received.message.projectInvitedBy', {
            invitingOrganisationName: invitation.intervention.invitingOrganisationName
          }))}
        </div>
      }
    </>
  );
}

MessageView.propTypes = {
  invitation: PropTypes.object.isRequired
};

export default MessageView;
